/**
 * Hex board math — odd-r offset, pointy-top, exactly like the original's
 * "brick" map (rows shift half a tile). Ported from legacy/admirals-return.html
 * (battle-tested). NEVER replace with square adjacency: everything assumes 6 neighbors.
 */

export type Coord = readonly [c: number, r: number];

export interface BoardSize {
  W: number;
  H: number;
}

export function key(c: number, r: number): string {
  return `${c},${r}`;
}

export function inBounds(g: BoardSize, c: number, r: number): boolean {
  return c >= 0 && r >= 0 && c < g.W && r < g.H;
}

const EVEN_DIRS: readonly Coord[] = [[1, 0], [-1, 0], [0, -1], [-1, -1], [0, 1], [-1, 1]];
const ODD_DIRS: readonly Coord[] = [[1, 0], [-1, 0], [1, -1], [0, -1], [1, 1], [0, 1]];

export function neighbors(g: BoardSize, c: number, r: number): Coord[] {
  const dirs = r % 2 === 0 ? EVEN_DIRS : ODD_DIRS;
  const out: Coord[] = [];
  for (const [dc, dr] of dirs) {
    const nc = c + dc;
    const nr = r + dr;
    if (inBounds(g, nc, nr)) out.push([nc, nr]);
  }
  return out;
}

/** odd-r offset → cube coordinates */
export function cube(c: number, r: number): readonly [number, number, number] {
  const q = c - ((r - (r & 1)) >> 1);
  return [q, r, -q - r];
}

export function hexDist(c1: number, r1: number, c2: number, r2: number): number {
  const a = cube(c1, r1);
  const b = cube(c2, r2);
  return Math.max(Math.abs(a[0] - b[0]), Math.abs(a[1] - b[1]), Math.abs(a[2] - b[2]));
}
